/* eslint-disable no-undef */
document.addEventListener('DOMContentLoaded', function () {
  if (document.getElementById('apps')) {
    new APP.HomePage();
  } else if (document.querySelector('.swipe-page')) {
    new APP.DetailPage();
  }
});

APP.AddonBar = function () {
  this.showAddOnLink();
};
APP.AddonBar.prototype.showAddOnLink = function () {
  var os = APP.utils.getClientOs();
  var browser = APP.utils.getClientBrowser();
  var nav = document.getElementById('nav');
  var url = 'https://www.seznam.cz/doplnky/?prohlizec=';
  var li = document.createElement('li');
  var a = document.createElement('a');

  if (!nav || (browser !== 'chrome' && browser !== 'firefox') || os === 'ios' || os === 'android' || os === 'windows-phone') {
    return;
  }

  a.href = url + browser;
  a.textContent = 'Seznam pro ' + browser.slice(0, 1).toUpperCase() + browser.slice(1);
  li.appendChild(a);
  nav.appendChild(li);
};
